// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface UserSetup {
    properties: {
        isSentinelUser: string;
        isThinkificUser: string;
    };
}

const initialHeaderState: UserSetup = {
    properties: {
        isSentinelUser: "false",
        isThinkificUser: "false",
    },
};

const reducer = {
    "xUserSetup/updateUserSetup": (
        draft: Draft<UserSetup>,
        action: {
            properties: {
                isSentinelUser: string;
                isThinkificUser: string;
            };
        },
    ) => {
        action?.properties?.isSentinelUser && (draft.properties.isSentinelUser = action?.properties?.isSentinelUser);
        action?.properties?.isThinkificUser && (draft.properties.isThinkificUser = action?.properties?.isThinkificUser);
    },
};

const xUserSetup = createTypedReducerWithImmer(initialHeaderState, reducer);

(reducers as any).xUserSetup = xUserSetup;

export type xUserSetupState = {
    xUserSetup: UserSetup;
};

type xUserSetupReducers = {
    isSentinelUser: typeof xUserSetup;
};

export type xUserSetupActions = Parameters<xUserSetupReducers[keyof xUserSetupReducers]>[1] | AnyAction;
